import styled, { css } from 'styled-components'
import ripple from '../../../../../styles/animations/ripple'
import { darken } from 'polished'

export const UsersSearchStyles = {
  Content: styled.div`
    display: flex;
    flex-direction: row;
    align-item: center;
    justify-content: space-between;
    gap: 10px;
    padding: 5px;
  `,
  Avatar: styled.div<{ src: any }>`
    min-width: 35px;
    min-height: 35px;
    max-width: 35px;
    max-height: 35px;
    border-radius: 100px;
    background-image: url(${({ src }) => src});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  `,
  Name: styled.div`
    font-size: 14px;
    font-weight: 700;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    color: ${({ theme }) => theme.colors.title};
  `,
  ContentRole: styled.div`
    ${ripple}
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0px;
    width: 135px;
    background-color: ${({ theme }) => darken(-0.6, theme.colors.primary)};
    padding: 10px 10px;
    border-radius: 10px;
  `,
  RoleIcon: styled.img`
    width: 25px;
    height: 25px;
  `,
  RoleName: styled.div`
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.title};
  `,
  Delete: styled.img`
    ${ripple}
    cursor: pointer;
    width: 20px !important;
    height: 20px !important;
  `,
}

export const Content = styled.div`
  flex-direction: column;
  max-height: 250px;
  overflow-y: auto;
`
